import { motion } from "framer-motion";
import { PRODUCTS } from "../data/products";
import { ProductCard } from "./ProductCard";

export const SupplierGrid = () => (
  <section id="suppliers" className="relative mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-32" data-testid="supplier-access-section">
    <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
      <div>
        <p className="text-[11px] tracking-[0.4em] uppercase text-gold mb-4">The vault · 08 drops</p>
        <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-white" data-testid="supplier-access-title">
          Supplier <span className="text-gold-purple italic">access</span>
        </h2>
      </div>
      <p className="max-w-sm text-sm sm:text-base text-violet-200/80 leading-relaxed">
        Vetted lists and guides built for resellers. Pay once, download instantly, and get a copy sent straight to your inbox.
      </p>
    </motion.div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5" data-testid="supplier-grid">
      {PRODUCTS.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
    </div>
  </section>
);
